module.exports = __webpack_public_path__ + "ec000860b393faeaad923bb96d910efc.svg";